import { z } from 'zod'
import { CabinClass } from './common'

export const CabinClassSchema = z.nativeEnum(CabinClass)
